import { Injectable, signal, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  private platformId = inject(PLATFORM_ID);
  
  // 기본값은 true로 설정하고, 브라우저 환경인 경우 실제 가로너비를 검사해 초기화합니다.
  isOpen = signal(true);
  isMobile = signal(false);
  
  private wasMobile = false;

  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      this.initSidebarState();
      window.addEventListener('resize', () => this.onResize());
    }
  }

  toggle() {
    this.isOpen.update(val => !val);
  }

  close() {
    this.isOpen.set(false);
  }

  open() {
    this.isOpen.set(true);
  }

  closeOnMobile() {
    if (isPlatformBrowser(this.platformId) && this.isMobile()) {
      this.close();
    }
  }

  private initSidebarState() {
    const mobileStatus = window.innerWidth < 992;
    this.isMobile.set(mobileStatus);
    this.wasMobile = mobileStatus;
    // 모바일에서는 기본적으로 닫히고, 데스크톱에서는 열린 상태로 시작합니다.
    this.isOpen.set(!mobileStatus);
  }

  private onResize() {
    const mobileStatus = window.innerWidth < 992;
    this.isMobile.set(mobileStatus);
    // 모바일 <-> 데스크톱 경계를 넘나들 때만 자동으로 상태를 동기화합니다.
    if (mobileStatus !== this.wasMobile) {
      this.wasMobile = mobileStatus;
      this.isOpen.set(!mobileStatus);
    }
  }
}
